import React, { Component } from 'react';
import { Dimensions } from 'react-native';
import { imageProcessor } from 'utils';
import { theme, css, IMAGE_SIZE, STATUSBAR_HEIGHT } from 'constants';
import { IcoClose } from 'icons';
import { Video, Modal, Link, View, CachedImage, isWeb, Image } from 'core';

const styles = css({
  container: {
    flex: 1,
    backgroundColor: 'black',
    justifyContent: 'center',
    alignItems: 'center'
  },
  back_btn: {
    zIndex: 10,
    position: 'absolute',
    left: isWeb ? 10 : 15,
    top: isWeb ? 10 : 35,
    width: 40,
    height: 40,
    borderRadius: 20,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0,0,0,0.2)'
  },
  web_container: {
    width: 600,
    height: 500,
    overflow: 'hidden',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'black'
  }
});

const dimensions = !isWeb ? Dimensions.get('window') : { width: 600, height: 500 };

let MediaViewer = {};
class MediaViewerProvider extends Component {
  state = {};
  show = options => {
    this.setState({ visible: true, options });
  };

  _getImageDimensions = size => {
    const viewer_size = imageProcessor.getDimensions(size.width / size.height, IMAGE_SIZE.LARGE);
    const ratio = size.width / size.height;
    const is_landscape = ratio > 1;
    let style = {};
    if (is_landscape) {
      style.width = viewer_size.width > dimensions.width ? dimensions.width : viewer_size.width;
      style.height = style.width / ratio;
    } else {
      style.height = viewer_size.height > dimensions.height ? dimensions.height : viewer_size.height;
      style.width = style.height * ratio;
    }
    return style;
  };

  componentDidMount() {
    MediaViewer = this;
  }

  close = () => this.setState({ visible: false });

  renderImage = options => {
    const { upload, size, url } = options || {};
    const img_size = size ? this._getImageDimensions(size) : {};
    if (url) {
      return <Image source={{ uri: url }} style={img_size} />;
    } else {
      return <CachedImage url={url} is_large upload={upload} size={img_size} />;
    }
  };

  render() {
    const { visible, options } = this.state;
    const { upload, asset_type, size, color, url } = options || {};
    return (
      <Modal visible={visible} animationType="fade" onRequestClose={this.close}>
        {upload || url ? (
          <View style={[isWeb ? styles.web_container : styles.container, !isWeb && color && { backgroundColor: `#${color}` }]}>
            <View style={[theme.absoluteFill, { backgroundColor: 'black', opacity: 0.5 }]} />
            <Link style={styles.back_btn} selected icon={IcoClose} onPress={this.close} selected_color="white" />
            {asset_type === 'PHOTO' ? this.renderImage(options) : <Video size={size && this._getImageDimensions(size)} upload={upload} url={url} />}
          </View>
        ) : null}
      </Modal>
    );
  }
}

export { MediaViewer, MediaViewerProvider };



// WEBPACK FOOTER //
// ./src/components/core/media_viewer.js